import React from "react";


const Contact = () => {

    const handleSubmit = async(event) => {
        event.preventDefault(); // Prevent default form submission behavior

        const formData = new FormData(event.target);       

        try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reviews` , {
            method: 'POST',
            body: formData
        });

        if (response.ok) {
            alert('Form submitted successfully');
            // Optionally reset the form
            event.target.reset();
        } else {
            throw new Error('Failed to submit form');
        }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Error submitting form. Please try again later.');
        }
    }
    return (<>
        <header className="site-header section-padding-img site-header-image">
            <div className="container">
                <div className="row">

                    <div className="col-lg-10 col-12 header-info">
                        <h1>
                            <span className="d-block text-primary">सेवेसाठी आभारी आहोत</span>
                            <span className="d-block text-dark">तुमच्या प्रश्नांचे स्वागत आहे</span>
                        </h1>
                    </div>
                </div>
            </div>

            <img src="images/header/positive-european-woman-has-break-after-work.jpg" className="header-image img-fluid" alt="" />
        </header>
        <section className="contact section-padding">
            <div className="container">
                <div className="row">

                    <div className="col-lg-6 col-12">
                        <h2 className="mb-4">Let's <span>begin</span></h2>

                        <form onSubmit={handleSubmit} className="contact-form me-lg-5 pe-lg-3" role="form">

                            <div className="form-floating">
                                <input type="text" name="name" id="name" className="form-control" placeholder="तुमचे नाव" required="" />

                                <label htmlFor="name">तुमचे नाव</label>
                            </div>

                            <div className="form-floating my-4">
                                <input type="email" name="email" id="email" pattern="[^ @]*@[^ @]*" className="form-control" placeholder="ई-मेल पत्ता" required="" />

                                <label htmlFor="email">ई-मेल पत्ता</label>
                            </div>

                            <div className="form-floating my-4">
                                <input type="subject" name="subject" id="subject" className="form-control" placeholder="विषय" required="" />

                                <label htmlFor="subject">विषय</label>
                            </div>

                            <div className="form-floating mb-4">
                                <textarea id="message" name="message" className="form-control" placeholder="आपला अभिप्राय नोंदवा" required="" style={{height: 160}}></textarea>

                                <label htmlFor="message">आपला अभिप्राय नोंदवा</label>
                            </div>

                            <div className="col-lg-5 col-6">
                                <button type="submit" className="form-control">Send</button>
                            </div>
                        </form>
                    </div>

                    <div className="col-lg-6 col-12 mt-5 ms-auto">
                        <div className="row">
                            <div className="col-6 border-end contact-info">
                                <h6 className="mb-3">New Business</h6>

                                <a href="mailto:hello@company.com" className="custom-link">
                                    contact@mangalpatrika.com
                                    <i className="bi-arrow-right ms-2"></i>
                                </a>
                            </div>

                            <div className="col-6 contact-info">
                                <h6 className="mb-3">Main Studio</h6>

                                <a href="mailto:studio@company.com" className="custom-link">
                                contact@mangalpatrika.com
                                    <i className="bi-arrow-right ms-2"></i>
                                </a>
                            </div>

                            <div className="col-6 border-top border-end contact-info">
                                <h6 className="mb-3">Our Office</h6>

                                <p className="text-muted">Pune, Maharashtra - 411052</p>
                            </div>

                            <div className="col-6 border-top contact-info">
                                <h6 className="mb-3">Our Socials</h6>

                                <ul className="social-icon">

                                    <li><a href="#" className="social-icon-link bi-messenger"></a></li>

                                    <li><a href="#" className="social-icon-link bi-youtube"></a></li>

                                    <li><a href="#" className="social-icon-link bi-instagram"></a></li>

                                    <li><a href="#" className="social-icon-link bi-whatsapp"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </>)
}

export default Contact;